// Intro slides

import React from 'react';
import { motion } from 'framer-motion';
import { IntroSlide as IntroSlideType } from '../../types';

interface IntroSlideProps {
  slide: IntroSlideType;
  isActive: boolean;
}

const IntroSlide: React.FC<IntroSlideProps> = ({ slide, isActive }) => {
  const slideVariants = {
    hidden: { opacity: 0, x: 20 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 }
  };

  return (
    <motion.div
      variants={slideVariants}
      initial="hidden"
      animate={isActive ? "visible" : "hidden"}
      exit="exit"
      transition={{ duration: 0.4, ease: "easeInOut" }}
      className="text-center space-y-6"
    >
      {slide.imagePath && (
        <div className="flex justify-center">
          <div className="w-32 h-32 rounded-2xl overflow-hidden bg-powder-100 border border-powder-200">
            <img
              src={slide.imagePath}
              alt={slide.title}
              className="w-full h-full object-cover"
              onError={(e) => {
                //Fallback for missing images
                const target = e.target as HTMLImageElement;
                target.src = `data:image/svg+xml;base64,${btoa(`
                  <svg width="192" height="192" viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="192" height="192" fill="#E2E8F0"/>
                    <circle cx="96" cy="80" r="20" fill="#6a9f6a"/>
                    <rect x="86" y="100" width="20" height="40" fill="#8B4513"/>
                    <text x="96" y="160" text-anchor="middle" font-family="Arial, sans-serif" font-size="14" fill="#64748B">
                      Forest
                    </text>
                  </svg>
                `)}`;
              }}
            />
          </div>
        </div>
      )}

      <div className="space-y-4">
        <h2 className="text-2xl font-bold text-powder-800">
          {slide.title}
        </h2>
        
        <p className="text-lg text-powder-600 leading-relaxed max-w-md mx-auto">
          {slide.content}
        </p>
      </div>
    </motion.div>
  );
};

export default IntroSlide;
